import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/left_ico.jpg'


const _withScopeId = n => (_pushScopeId("data-v-28a92f62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pc-BasicInfo" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cvv-name" }, "C V V:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cvv-img"
}, null, -1))

import { Row, Col } from "vant";
import { month, year } from "@/assets/data/list";
import { getOrder } from "../hooks/order";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicInfo',
  props: {
  errorField: {
    type: String,
    default: "",
  },
},
  setup(__props) {



const { order } = getOrder();
const monthList = month;
const yearList = year;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Row), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Card Number:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["card-input", { err: __props.errorField === 'CardNo' }]),
              oninput: "if(value.length >= 16) value=value.slice(0,16)",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(order).CardNo) = $event)),
              name: "CardNo"
            }, null, 2), [
              [_vModelText, _unref(order).CardNo]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Expiration Date:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Row), {
              align: "center",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      class: "month",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(order).CardExpireMonth) = $event)),
                      name: "CardExpireMonth"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthList), (month) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: month,
                          key: month
                        }, _toDisplayString(month), 9, _hoisted_2))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(order).CardExpireMonth]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      class: "year",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(order).CardExpireYear) = $event)),
                      name: "CardExpireYear"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearList), (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: year,
                          key: year
                        }, _toDisplayString(year), 9, _hoisted_3))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(order).CardExpireYear]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["cvv-value", { err: __props.errorField === 'Cvv2' }]),
                      oninput: "if(value.length >= 3) value=value.slice(0, 3)",
                      type: "password",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(order).Cvv2) = $event)),
                      name: "Cvv2"
                    }, null, 2), [
                      [_vModelText, _unref(order).Cvv2]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Col), null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("First Name:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(order).FirstName) = $event)),
              name: "FirstName",
              class: _normalizeClass({ err: __props.errorField === 'FirstName' })
            }, null, 2), [
              [_vModelText, _unref(order).FirstName]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Row), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Col), { class: "name" }, {
          default: _withCtx(() => [
            _createTextVNode("Last Name:")
          ]),
          _: 1
        }),
        _createVNode(_unref(Col), null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(order).LastName) = $event)),
              name: "LastName",
              class: _normalizeClass({ err: __props.errorField === 'LastName' })
            }, null, 2), [
              [_vModelText, _unref(order).LastName]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})